import { evaluationToPathNameMap } from './getEvaluation';
export const getGovToPathNameMap = {
    ...evaluationToPathNameMap,
};
